import { FocusTrap } from "@nx-paeonia/utils-events";
import { signal } from "@nx-paeonia/utils-signals";
import { type AnimationSequence, animate, stagger } from "motion";
import { MenuAim } from "./helpers/menu-aim.helper.js";

function _initMegaMenus() {
	const megaMenus = document.querySelectorAll<HTMLElement>(".mega-menu");

	megaMenus.forEach((menu) => {
		const isOpen = signal(true);
		const anchor = menu.previousElementSibling as HTMLElement | null;
		const wrapper = menu.parentElement as HTMLElement | null;

		if (!anchor || !wrapper) {
			return;
		}

		new MenuAim({
			trigger: wrapper,
			menu,
			activate: () => {
				isOpen.update(() => true);
			},
			deactivate: () => {
				isOpen.update(() => false);
			},
		});

		const focusTrap = new FocusTrap({
			element: menu,
			blockScroll: true,
		});

		isOpen.subscribe((open) => {
			if (open) {
				focusTrap.activate();
				animateMegaMenuOpen(menu);
			} else {
				focusTrap.deactivate();
				animateMegaMenuClose(menu);
			}
		});

		isOpen.update(() => false);
	});
}

_initMegaMenus();

function animateMegaMenuOpen(menu: HTMLElement): void {
	const animationSequence: AnimationSequence = [
		// Animate the menu to be visible and positioned
		[menu, { display: "grid" }, { duration: 0 }],
		[menu, { opacity: [0, 1], translateX: [-10, 0] }],

		// Animate the menu items and sub items at the same time for a nice staggered effect.
		[menu.querySelectorAll(".mega-menu-root-item, ul li"), { opacity: [0, 1], translateY: [10, 0] }, { delay: stagger(0.01) }],
	];

	animate(animationSequence);
}
function animateMegaMenuClose(menu: HTMLElement): void {
	const animationSequence: AnimationSequence = [
		// Animate the menu items and sub items to fade out and move up
		[menu.querySelectorAll(".mega-menu-root-item, ul li"), { opacity: [1, 0], translateY: [0, -10] }, { delay: stagger(0.01) }],

		// Animate the menu to fade out and move up, then hide it
		[menu, { display: "none" }, { duration: 0 }],
	];

	animate(animationSequence);
}
